export default {
  namespaced: true,
  namespace: "clientesStore",
  state: {      
    barcode: [
        {
          model: 'C740',
          commands: [
            { value: '%#IFSN0$1', text: 'Wireless', description: 'Habilita o modo wireless', input: false },
            { value: '%#IFSN0$4', text: 'Bluetooth', description: 'Habilita o modo bluetooth', input: false },

            { value: '%#INVMD', text: 'Off-line', description: 'As leituras serão armazenadas no coletor sem transmitir a cada coleta', input: false },
            { value: '%#NORMD', text: 'On-line', description: 'As leituras serão enviadas a cada coleta', input: false },
            { value: '%#TXMEM', text: 'Baixar Leituras', description: 'Descarrega todas as leituras armazenadas no coletor para o sistema', input: true, baixar: true },
            { value: '%#+TCNT', text: 'Total Leituras', description: 'Mostra quantas leituras foram armazenadas no coletor', input: true },
            { value: '%#*NEW*', text: 'Limpar leituras', description: 'Limpa todas as leituras armazenadas no coletor', input: false },
        
            { value: '$BUZZ#0', text: 'Sem Volume', description: 'Desliga o beep da leitura', input: false },
            { value: '$BUZZ#1', text: 'Volume Alto', description: 'Ativa o volume alto', input: false },
            { value: '$BUZZ#2', text: 'Volume Médio', description: 'Ativa o volume médio', input: false },
            { value: '$BUZZ#3', text: 'Volume Baixo', description: 'Ativa o volume baixo', input: false },

            { value: '0212@\r', text: 'Habilitar Enter', description: 'Adiciona quebra de linha após a leitura', input: false },
            { value: '0212@', text: 'Desabilitar Enter', description: 'Remove quebra de linha após a leitura', input: false },

            { value: '1000031', text: 'Habilitar EAN13', description: '', input: false },
            { value: '1000030', text: 'Desabilitar EAN13', description: '', input: false },
            { value: '1000041', text: 'Habilitar EAN8', description: '', input: false },
            { value: '1000040', text: 'Desabilitar EAN8', description: '', input: false },
            { value: '1000101', text: 'Habilitar EAN128', description: '', input: false },
            { value: '1000100', text: 'Desabilitar EAN128', description: '', input: false }
          ]
        },
        {
            model: 'datalogic',
            commands: []
        }
      ]
    },

    getters: {

        gtxbarcodebymodel: state => model => state.barcode.find(f => f.model == model)

    }
}